// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.subtitle-1[data-v-3e16f7c2] {\n  font-weight: bold !important;\n  margin-top: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
